var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.251C10.8221 13.6815 11.233 14.0378 11.7049 14.2957C12.1768 14.5535 12.6986 14.7068 13.235 14.7452C13.7713 14.7836 14.3097 14.7062 14.8135 14.5183C15.3173 14.3303 15.7748 14.0363 16.155 13.656L18.405 11.406C19.0881 10.6987 19.4661 9.75143 19.4575 8.7682C19.449 7.78496 19.0546 6.84441 18.3593 6.14913C17.664 5.45385 16.7235 5.05947 15.7403 5.05092C14.757 5.04238 13.8098 5.42036 13.1025 6.10345L11.8125 7.38595",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5006 11.7499C13.1785 11.3193 12.7676 10.963 12.2957 10.7052C11.8238 10.4474 11.302 10.2941 10.7657 10.2557C10.2293 10.2173 9.69095 10.2946 9.18713 10.4826C8.68331 10.6705 8.2258 10.9646 7.84564 11.3449L5.59564 13.5949C4.91255 14.3022 4.53457 15.2494 4.54311 16.2327C4.55165 17.2159 4.94604 18.1565 5.64132 18.8517C6.3366 19.547 7.27715 19.9414 8.26038 19.95C9.24362 19.9585 10.1909 19.5805 10.8981 18.8974L12.1806 17.6149",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.ebf0517113a16712c7c71a4ea91e27c6.svg";
export { ForwardRef as ReactComponent };